import React from 'react';
import { getSessionItem } from '../../../../webStorage/sessionStorage';
import './skeleton.css';

const Skeleton = ({ page = 'default', block = null, count = 1, height = '60px' }) => {
  const getMenuCardSkeleton = () => (
    <div className='menu-item'>
      <div className='menu-item__description'>
        <div className='description__top'>
          {new Array(2).fill(0).map(() => (
            <div className='skeleton line'></div>
          ))}
        </div>
        <div className='skeleton line item-price'></div>
      </div>
      <div className='menu-item__image skeleton square'></div>
    </div>
  );

  if (block === 'line') {
    return (
      <div className='line__container'>
        {new Array(count).fill(0).map(() => (
          <div className='skeleton line'></div>
        ))}
      </div>
    );
  }

  if (block === 'square') {
    return (
      <div className='square__container'>
        {new Array(count).fill(0).map(() => (
          <div className='skeleton square'></div>
        ))}
      </div>
    );
  }

  if (block === 'roundedRectangle') {
    return (
      <div className='rounded-rectangle__container'>
        {new Array(count).fill(0).map(() => (
          <div className='skeleton rounded-rectangle'></div>
        ))}
      </div>
    );
  }

  if (block === 'rectangle') {
    return (
      <div className='rectangle__container'>
        {new Array(count).fill(0).map(() => (
          <div className='skeleton rectangle' style={{ height }}></div>
        ))}
      </div>
    );
  }

  if (block === 'menuCard') {
    return (
      <div className='menu__skeleton menu-card skeleton__body'>
        <div className='skeleton category-dropdown'></div>
        <div className='menu-items'>
          <div className='line skeleton category'></div>
          <div className='line skeleton sub-category'></div>
          {new Array(count).fill(0).map(() => getMenuCardSkeleton())}
        </div>
      </div>
    );
  }

  if (page === 'menu') {
    return (
      <div className='menu__skeleton skeleton__body'>
        <div className='skeleton header'></div>
        <div className='skeleton order-type'></div>
        <div className='skeleton promo'></div>
        <div className='skeleton category-dropdown'></div>
        <div className='menu-items'>
          <div className='line skeleton category'></div>
          <div className='line skeleton sub-category'></div>
          {new Array(3).fill(0).map(() => getMenuCardSkeleton())}
        </div>
      </div>
    );
  }

  if (page === 'cart') {
    return (
      <div className='cart__skeleton skeleton__body'>
        <div className='skeleton header'></div>
        <div className='skeleton items'></div>
        <div className='skeleton instructions'></div>
        <div className='skeleton coupon'></div>
        <div className='skeleton loyalty-cashback'></div>
        <div className='skeleton loyalty-banner'></div>
        <div className='skeleton bill'></div>
        <div className='skeleton footer'></div>
      </div>
    );
  }

  if (page === 'orderStatus') {
    return (
      <div className='order-status__skeleton skeleton__body'>
        <div className='skeleton header'></div>
        <div className='skeleton banner'></div>
        <div className='skeleton chat'></div>
        <div className='skeleton items'></div>
        <div className='skeleton line'></div>
        <div className='skeleton promo'></div>
        <div className='skeleton bill'></div>
        <div className='skeleton footer'></div>
      </div>
    );
  }

  if (page === 'orderSummary') {
    return (
      <div className='order-summary__skeleton skeleton__body'>
        <div className='skeleton header'></div>
        <div className='order-summary__content'>
          <div className='skeleton title'></div>
          <div className='skeleton items'></div>
          <div className='skeleton bill'></div>
          <div className='skeleton line'></div>
        </div>
        <div className='skeleton footer'></div>
      </div>
    );
  }

  if (page === 'profile') {
    return (
      <div className='profile__skeleton skeleton__body'>
        <div className='skeleton header'></div>
        <div className='skeleton profile'></div>
        <div className='tabs'>
          {new Array(4).fill(0).map(() => (
            <div className='skeleton tab'></div>
          ))}
        </div>
        {!getSessionItem('scanThroughQr') && <div className='skeleton footer'></div>}
      </div>
    );
  }

  if (page === 'payment') {
    return (
      <div className='payment__skeleton skeleton__body'>
        <div className='skeleton header'></div>
        <div className='cashbacks'>
          <div className='skeleton cashback'></div>
        </div>
        <div className='payment__options'>
          <div className='options'>
            <div className='skeleton option__header'></div>
            <div className='square__container'>
              {new Array(8).fill(0).map(() => (
                <div className='skeleton square'></div>
              ))}
            </div>
          </div>
          <div className='options'>
            <div className='skeleton option__header'></div>
            <div className='square__container'>
              {new Array(4).fill(0).map(() => (
                <div className='skeleton square'></div>
              ))}
            </div>
          </div>
        </div>
        <div className='skeleton footer'></div>
      </div>
    );
  }

  if (page === 'orderHistory') {
    return (
      <div className='order-history__skeleton skeleton__body'>
        <div className='skeleton header'></div>
        <div className='order-history__content'>
          <div className='skeleton line'></div>
          {new Array(2).fill(0).map(() => (
            <div className='order-block'>
              <div className='skeleton order-block__top'></div>
              <div className='skeleton order-block__bottom'></div>
            </div>
          ))}
        </div>
        {!getSessionItem('scanThroughQr') && <div className='skeleton footer'></div>}
      </div>
    );
  }

  if (page === 'loyalty') {
    return (
      <div className='loyalty__skeleton skeleton__body'>
        <div className='skeleton header'></div>
        <div className='skeleton loyalty-info'></div>
        <div className='skeleton loyalty-instruction'></div>
        {new Array(3).fill(0).map(() => (
          <div className='skeleton loyalty-res'></div>
        ))}
      </div>
    );
  }

  return <div className='skeleton default__skeleton skeleton__body'></div>;
};

export default Skeleton;
